<template>
    <div class="text-margin">
        <el-form-item
            label="备忘"
        >
            <el-input
                v-model="newValue"
                size="mini"
                type="textarea"
                rows="10"
            />
        </el-form-item>
    </div>
</template>

<script>

export default {
    name: 'FormNotes',
    props: {
        value: {
            type: Object,
            default: function () {
                return { context: '' }
            }
        }
    },
    data() {
        return {
            module: {
                notes: {
                    context: ''
                }
            },
        }
    },
    created(){
        this.$emit('input', { context: '' })
    },
    computed: {
        newValue: {
            get: function() {
                return this.value ? this.value.context : ''
            },
            set: function(value) {
                this.$emit('input', { context: value })
            }
        }
    },
    mounted(){
    },
    methods: {
    }
}
</script>

<style scoped>

</style>
